import service from "@/utils/request";

// 提审审核列表
export function getWithdrawalPageListApi(params) {
    return service({
        url: "/withdrawalApplication/getAllByPage",
        method: "get",
        params,
    });
}
// 查询打款状态
export function queryPaymentStatus(params) {
    return service({
        url: "/withdrawalApplication/queryPaymentStatus",
        method: "get",
        params,
    });
}
// 查询灵工账户余额
export function queryZjyzBalance(params) {
    return service({
        url: "/withdrawalApplication/queryZjyzBalance",
        method: "get",
        params,
    });
}

// 提现审核 通过
export function updateWithdrawalPassApi(data) {
    return service({
        url: "/withdrawalApplication/pass",
        method: "post",
        data,
    });
}

// 提现审核 拒绝
export function updateWithdrawalRejectApi(data) {
    return service({
        url: "/withdrawalApplication/reject",
        method: "post",
        data,
    });
}

export function addWithdrawalPassOrRejectApi(data) {
    return service({
        url: "/withdrawalApplication/add",
        method: "post",
        data,
    });
}


export function queryWithdrawTitleApi(params) {
    return service({
        url: "/withdrawalApplication/queryWithdrawTitle",
        method: "get",
        params,
    });
}
